import { ApiResponse, err, getAxios, postAxios, processError, res } from "./axios";

// import { setupCache, buildWebStorage } from 'axios-cache-interceptor/dev';

// const axios = setupCache(Axios, { 
//   debug: console.log,
//   methods: ['get', 'post'],
//   // As localStorage is a public storage, you can add a prefix
//   // to all keys to avoid collisions with other code.
//   storage: buildWebStorage(sessionStorage, 'axios-cache:')
// });
// src/utils/cache.js



export const locationSearch = async (searchTerm: string):Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/maps/location-search?q=${searchTerm}`)
    const response = result?.data?.response || null
    return {
      error: 200,
      message: null,
      response
    }
  } catch {
    return err("Error fetching map location.")
  }
}

interface GetMeshQuery {
  coords: string | null
  model?: string | null
  provider?: string | null
  geography?: string | null
  version?: string | null
  averages?: boolean | null
}

export const getMesh = async ({
  coords,
  model,
  provider,
  geography,
  version = null,
  averages = false,
}: GetMeshQuery):Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/maps/get-mesh/${coords?.replace(' ', '')}/${provider || 'null'}/${model || 'null'}/${geography || 'null'}/${version}/${averages}`, false)
    const response = result?.data?.rows || null

    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error fetching mesh data.", true)
    return err(message, status)
  }
}



interface GetMeshDataQuery {
  lat?: string | number | null
  lon?: string | number | null
  model?: string | null
  provider?: string | null
  geography?: string | null
  version?: string | null
  averages?: boolean | null
  filename?: string | null
  order_id?: string | number | null
}

export const getMeshData = async ({
  ...props
}: GetMeshDataQuery):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/maps/get-mesh-data/`,{
      ...props
    }, false)
    const response = result?.data?.rows || null

    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error fetching mesh data.", true)
    return err(message, status)
  }
}
export const getArea = async (coords: string | number[]):Promise<ApiResponse> => {
  try {
    const bbox = Array.isArray(coords) ? coords.join(',') : coords
    const result = await getAxios(`/api/v1/maps/get-area?q=${bbox}`, false)
    const response = result?.data?.response || null
    return {
      error: 200,
      message: null,
      response
    }
  } catch {
    return err("Error fetching mesh data.")
  }
}

export const getAreaInfo = async (coords: string | number[], zoom: number):Promise<ApiResponse> => {
  try {
    const bbox = Array.isArray(coords) ? coords.join(',') : coords
    const result = await getAxios(`/api/v1/maps/get-area-info/${bbox}/${zoom}`, false)
    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error fetching area info.")
    return err(message, status)
  }
}

interface GetAreaInfoByModelProps {
  feature: string
  coords: number[]
  model?: string | null
  provider?: string | null
  geography?: string | null
  version?: string | null
}

export const getAreaInfoByModel = async ({
  coords,
  feature,
  model,
  provider,
  geography,
  version = null,
}: GetAreaInfoByModelProps):Promise<ApiResponse> => {
  try {
    const bbox = Array.isArray(coords) ? coords.join(',') : coords
    const result = await getAxios(`/api/v1/maps/get-area-info-by-model/${bbox}/${model}/${provider}/${geography}/${version}/${feature}`, false)
    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error fetching area info by model.")
    return err(message, status)
  }
}

interface GetGeoJsonByBboxProps {
  coords: number[] | string
  model?: string | null
  provider?: string | null
  geography?: string | null
  version: string | null
}

export const getGeoJsonByBbox = async ({
  coords,
  model,
  provider,
  geography,
  version,
}: GetGeoJsonByBboxProps):Promise<ApiResponse> => {
  try {
    const bbox = Array.isArray(coords) ? coords.join(',') : coords
    const result = await getAxios(`/api/v1/maps/get-geo-json-by-bbox/${bbox}/${model}/${provider}/${geography}/${version}`, false)
    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error fetching Geo JSON.")
    return err(message, status)
  }
}

